var moduleMap = {
	"./Bootstrap": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_sour-8ee28c"), __webpack_require__.e("node_modules_moment_locale_sync_recursive_-src_bootstrapDocuments_ts-webpack_sharing_consume_-669d7e"), __webpack_require__.e("src_services_cookies_js-webpack_sharing_consume_default_vue_vue")]).then(() => (() => ((__webpack_require__(/*! ./src/bootstrapDocuments.ts */ "./src/bootstrapDocuments.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});